import { Outlet, useLocation } from 'react-router-dom';
import { InstallBanner } from '@/components/common';

export function AuthLayout() {
  // A honorarac opening their invite link (issue #58) has no use for the app
  // install prompt: they will never sign in.
  const { pathname } = useLocation();
  const showInstall = !pathname.startsWith('/potvrda-rasporeda/');

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-admin-bg p-4">
      {showInstall && <InstallBanner />}
      <Outlet />
    </div>
  );
}
